import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import BranchGateway from '~apis/branch';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetRegionListing(api: BranchGateway): SagaWatcherReturnType {
    yield takeEvery('branch/branchGetRegionListingAttempt', handleGetRegionListing, api);
}

function* handleGetRegionListing(api: BranchGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { index } = reduxState.branch.regionListing;

    if (!index && index !== 0) {
        yield put(combinedActions.branchGetRegionListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    const response = yield* call([api, api.getRegionListing], {
        authToken,
        index,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.branchGetRegionListingFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.branchGetRegionListingSuccess(response.data));
    }
}
